module.exports = __webpack_public_path__ + "img/wallet-white.4243dd27.svg";